import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { SetupOnBoarding } from '~/app/index';
class ViewOnBoarding extends Component {
    constructor(props){
        super(props);
        this.state = {
            showBoardingModal: false,
            onModalClose: false,
        };

        //bg_color_fix
        if (window.location.pathname === "/viewBoarding") {
            document.body.className = "fix_bg";
        }
    }

    componentDidMount(){
        let state = this.props.history.location.state
        if (state) {
            if(state.userType === 1) {
                this.setState({ showBoardingModal: true });
            }
        } else {
            console.log("Modal Not gonna show due to not getting state from login");
        }
    }


    formDatas = () => {

        let onBoardingData = {
            company_name: document.getElementById('company_name').value,
            company_address: document.getElementById('company_address').value,
            company_city: document.getElementById('city').value,
            company_zip: document.getElementById('zip_code').value,
            company_state: document.getElementById('state').value,
            company_phone: document.getElementById('phone').value,
            company_billing_id: document.getElementById('billing_id').value,
            company_billing_tax_id: document.getElementById('tax_id').value,
            company_billing_npi: document.getElementById('billing_npi').value,
            company_billing_address: document.getElementById('billing_address').value,
            company_billing_address_2: document.getElementById('billing_address_2').value,
            company_billing_city: document.getElementById('billing_city').value,
            company_billing_zip: document.getElementById('billing_zip').value,
            company_billing_state: document.getElementById('billing_state').value,
            company_payers: document.getElementById('selectedPayers').getAttribute('value'),
            company_brokers: document.getElementById('selectedBrokers').getAttribute('value'),
            dispatch_info: document.getElementById('dispatchInfo').value
        };


        return { ...onBoardingData };
    }

    saveTemporary = () => {

        localStorage.setItem('tempOnboardingData', JSON.stringify({ ...this.formDatas() }));

    }

    handlehideShowBoarding = () => {

        if (this.state.showBoardingModal) {
            localStorage.setItem('is_new', 0);
            this.saveTemporary();
        }
        this.setState({
            showBoardingModal: this.state.showBoardingModal ? false : true,
            onModalClose: true,
        });
    }

    render() {

        if (this.state.onModalClose) {
            document.body.className = "fix_bgs";
            return <Redirect to="/logout" />
        }
        // if (localStorage.getItem('is_new') !== "1") {
        //     document.body.className = "fix_bgs";
        //     return <Redirect to="/logout" />
        // }
        // if (localStorage.getItem('userType') !== "1") {
        //     document.body.className = "fix_bgs";
        //     return <Redirect to="/logout" />
        // }

        return(
            <div className="container-fluid login_page_wrapper">
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <SetupOnBoarding
                            show={this.state.showBoardingModal}
                            onHideShowBoarding={this.handlehideShowBoarding}
                            formData={this.formDatas}
                        />
                    </div>
                    <div className="col-md-4"></div>
                </div>
            </div>
        );
    }

};

export default ViewOnBoarding;


// WEBPACK FOOTER //
// ./src/app/setup_onboarding/viewOnBoarding.js